const genericErrorCodes = {
  'generic-error-message': 'An unexpected error occurred'
};

export default genericErrorCodes;
